import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function MicOnIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M25 16.4941C25 15.8941 24.546 15.4353 23.9522 15.4353C23.3585 15.4353 22.9044 15.8941 22.9044 16.4941C22.9044 20.6235 19.5864 23.9765 15.5 23.9765C11.4136 23.9765 8.09559 20.6235 8.09559 16.4941C8.09559 15.8941 7.64154 15.4353 7.04779 15.4353C6.45404 15.4353 6 15.8941 6 16.4941C6 21.4 9.63235 25.5294 14.4522 26.0588V28.8824H10.6452C10.0515 28.8824 9.59743 29.3412 9.59743 29.9412C9.59743 30.5412 10.0515 31 10.6452 31H20.3548C20.9485 31 21.4026 30.5412 21.4026 29.9412C21.4026 29.3412 20.9485 28.8824 20.3548 28.8824H16.5478V26.0588C21.3676 25.5294 25 21.4 25 16.4941Z"
        fill="currentColor"
      />
      <path
        d="M25 16.4941C25 15.8941 24.546 15.4353 23.9522 15.4353C23.3585 15.4353 22.9044 15.8941 22.9044 16.4941C22.9044 20.6235 19.5864 23.9765 15.5 23.9765C11.4136 23.9765 8.09559 20.6235 8.09559 16.4941C8.09559 15.8941 7.64154 15.4353 7.04779 15.4353C6.45404 15.4353 6 15.8941 6 16.4941C6 21.4 9.63235 25.5294 14.4522 26.0588V28.8824H10.6452C10.0515 28.8824 9.59743 29.3412 9.59743 29.9412C9.59743 30.5412 10.0515 31 10.6452 31H20.3548C20.9485 31 21.4026 30.5412 21.4026 29.9412C21.4026 29.3412 20.9485 28.8824 20.3548 28.8824H16.5478V26.0588C21.3676 25.5294 25 21.4 25 16.4941Z"
        fill="currentColor"
      />
      <path
        d="M15.5 1C12.2868 1 9.66728 3.64706 9.66728 6.89412V16.4588C9.66728 19.7412 12.2868 22.3529 15.5 22.3882C18.7132 22.3882 21.3327 19.7412 21.3327 16.4941V6.89412C21.3327 3.64706 18.7132 1 15.5 1Z"
        fill="currentColor"
      />
      <path
        d="M15.5 1C12.2868 1 9.66728 3.64706 9.66728 6.89412V16.4588C9.66728 19.7412 12.2868 22.3529 15.5 22.3882C18.7132 22.3882 21.3327 19.7412 21.3327 16.4941V6.89412C21.3327 3.64706 18.7132 1 15.5 1Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
